<template>
  <div>
    <div class="team-page">
      <div class="tab-box">
        <ul class="tab-btn-list">
          <!-- 경기일정/결과, 팀순위, 선수랭킹 -->
          <li v-for="(tab, index) in tabList" :key="index" :class="{active: tab.isActive}">
            <router-link :to="{name: tab.name}">
              {{tab.title}}
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="container">
      <div class="tab-box">
        <ul class="tab-btn-list match match-sub-tab">
          <!-- ALL, K리그, FA컵 -->
          <li v-for="(tab, index) in subTabList" :key="index" :class="{active:currentTab === index}"
              @click="tabIndexChange(currentTab)">
            <a href="#" @click.prevent="currentTab = index">{{ tab }}</a>
          </li>
        </ul>
      </div>

      <!-- 년도/월 -->
      <DateSlider :key="year + '-' + month" :year-state="true" :month-state="true" :first-month="2" :active-year="year" :active-month="Number(month)" @year="yearChange" @month="monthChange"/>

      <!-- 리스트 -->
      <MatchResults v-bind:list="tabContents" v-bind:slide-year="year" :current="currentTab" class="match-list"/>
    </div>
  </div>
</template>

<script>
import DateSlider from '@/components/Common/DateSlider.vue';
import MatchResults from '@/components/Match/MatchResults.vue';
import dayjs from 'dayjs';
import {leagueName, oldLeagueName} from "@/lib/match";

export default {
  name: 'MatchList',
  components: {
    MatchResults,
    DateSlider,
  },
  data() {
    return {
      tabList: [],
      currentTab: 0,
      subTabList: ['ALL', 'K LEAGUE', '코리아컵'],
      tabContents: [],
      year: dayjs().format('YYYY'),
      month: dayjs().format('MM'),
    }
  },
  watch: {
    $route(to, from) {
      // 쿼리 → year/month 동기화
      this.year = to.query.year || dayjs().format('YYYY');
      this.month = to.query.month || dayjs().format('MM');
      this.getMatch();
    }
  },
  async created() {
    const menuList =
      this.$router.options.routes &&
      this.$router.options.routes.filter((x) => {
        return x.path === this.$route.matched[0].path ? x : '';
      });

    const subMenuList =
      menuList[0].children &&
      menuList[0].children.filter((x) => {
        return x.meta && x.meta.title;
      });

    Object.entries(subMenuList).forEach(([, value]) => {
      const result = {
        title: value.meta.title,
        name: value.name,
        isActive: this.$route.name === value.name,
      };
      this.tabList.push(result);
    });

    // query 우선 반영
    this.year = this.$route.query.year || dayjs().format('YYYY');
    this.month = this.$route.query.month || dayjs().format('MM');

    const hasQuery = !!(this.$route.query.year && this.$route.query.month);
    const isFeb = Number(this.month) === 2;

    // 1) 쿼리 있으면 그대로 해당 월 조회
    if (hasQuery) {
      await this.getMatch();
      return;
    }

    // 2) 쿼리 없고 현재월이 2월인 경우: 2월 먼저 조회 → 없으면 month를 3월로 바꾸고 재조회
    if (isFeb) {
      const list = await this.getMatch(); // 2월 데이터
      const hasData = Array.isArray(list) && list.length > 0;

      if (!hasData) {
        // 여기서 month를 변경 → DateSlider의 :active-month도 같이 변경됨
        this.month = '03';
        await this.$nextTick();
        this.$router.replace({ query: { year: this.year, month: this.month } });
        return;
      }
    }
    // 3) 쿼리 없고 현재월이 2월이 아니면 현재월로 조회
    await this.getMatch();
  },
  methods: {
    tabIndexChange(val) {},
    yearChange(data) {
      this.year = data;
      this.month = '1';
      this.$router.push({ query: { year: this.year, month: this.month } });
    },
    monthChange(data) {
      this.month = data;
      if (
        Number(this.$route.query.year) !== Number(this.year) ||
        Number(this.$route.query.month) !== Number(this.month)
      ) {
        this.$router.push({ query: { year: this.year, month: this.month } });
      }
    },
    async getMatch() {
      if (this.year < 2013) {
        return await this.getOldMatchList();
      } else {
        return await this.getMatchList();
      }
    },
    async getMatchList() {
      this.tabContents = [];
      const { data } = await this.$http.get(
        `/game/month?year=${this.year}&month=${this.month}`
      );

      if (data.success) {
        const game =
          data.data && Array.isArray(data.data.game) ? data.data.game : [];
        this.tabContents = game;
        this.setList(this.tabContents, 'new');
        return game;
      }
      return [];
    },
    async getOldMatchList() {
      this.tabContents = [];
      const { data } = await this.$http.get(
        `/past_game/month?year=${this.year}&month=${this.month}`
      );

      if (data.success) {
        const game =
          data.data && Array.isArray(data.data.game) ? data.data.game : [];
        this.tabContents = game;
        this.setList(this.tabContents, 'old');
        return game;
      }
      return [];
    },
    setList(data, type) {
      data.map((item) => {
        if (type === 'old') {
          item.home_team_goal = item.home_team_goal.total;
          item.away_team_goal = item.away_team_goal.total;
          item.league_name = oldLeagueName(item.meet_seq, item.meet_name);
        } else {
          item.league_name = leagueName(item.meet_name);
        }

        item.isEnd = item.audience !== 0;
        item.game_time = item.game_time.substring(0, 5);

        item.league_idx =
          item.league_name === 'kleague'
            ? 1
            : item.league_name === 'facup'
              ? 2
              : 1;

        item.meet_year = item.game_date.substring(0, 4);
        item.detail = `${item.meet_year}_${item.meet_seq}_${item.game_id}`;

        item.matchType = item.home_team === 'K07' ? '홈' : '어웨이';
      })
    }
  }
}
</script>
